<script setup>
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import InhouseStatistics from '@/components/StatisticData.vue';
import InhouseDataTable from '@/components/DataTable.vue';
import iconInHouse from '../../../public/icons/home-location.svg';
import iconDeluxe from '../../../public/icons/business-value.svg';
import iconStudio from '../../../public/icons/space-station-moon.svg';
import iconHoneymoon from '../../../public/icons/rings-wedding.svg';
import iconFamily from '../../../public/icons/family-pants.svg';
import { ref } from 'vue';


// const modal = defineModel()

</script>

<template>
    <HeaderContent title="In House"/>
    <ActionContent :filterDate="false" :cta="false"/>
    <InhouseStatistics title="In House Statistics" :data="statistics" />
    <InhouseDataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions"/>
</template>


<script>
const data = [
    {
        room_no : 'A01',
        type_room : 'Deluxe',
        guest_name : 'Bones',
        check_in : '13/02/2005 12:00',
        check_out : '14/02/2005',
        days_left : '1 day',
    },
    {
        room_no : 'A02',
        type_room : 'Super Deluxe',
        guest_name : 'Bones',
        check_in : '13/02/2005 12:00',
        check_out : '14/02/2005',
        days_left : '1 day',
    },
    {
        room_no : 'A03',
        type_room : 'Honeymoon',
        guest_name : 'Bones',
        check_in : '13/02/2005 12:00',
        check_out : '14/02/2005',
        days_left : '1 day',
    },
    {
        room_no : 'A04',
        type_room : 'Family',
        guest_name : 'Bones',
        check_in : '13/02/2005 12:00',
        check_out : '14/02/2005',
        days_left : '1 day',
    },
    {
        room_no : 'A05',
        type_room : 'Studio',
        guest_name : 'Bones',
        check_in : '13/02/2005 12:00',
        check_out : '14/02/2005',
        days_left : '1 day',
    },
    
]
const statistics = ref([
    {
        label: 'Total',
        key: 'In-House',
        value: 24,
        color: 'primary',
        icon: iconInHouse,
    },
    {
        label: 'Total',
        key: 'Deluxe',
        value: 3,
        color: 'danger',
        icon: iconDeluxe,
    },
    {
        label: 'Total',
        key: 'Studio',
        value: 3,
        color: 'success',
        icon: iconStudio,
    },
    {
        label: 'Total',
        key: 'Family',
        value: 3,
        color: 'orange',
        icon: iconFamily,
    },
    {
        label: 'Total',
        key: 'Honeymoon',
        value: 3,
        color: 'primary',
        icon: iconHoneymoon,
    },
])  
const headers = ref([
    {key : 'is_online',label:'',class:'p-2',tdClass:' align-middle', sortable: true},
    {key : 'room_no', class: 'text-center',tdClass:' align-middle', sortable: true},
    {key : 'type_room', class: 'text-center',tdClass:' align-middle', sortable: true},
    {key : 'guest_name',tdClass:' align-middle', sortable: true},
    {key : 'check_in', class:'text-left',tdClass:' align-middle', sortable: true},
    {key : 'check_out',tdClass:' align-middle', sortable: true },
    {key : 'days_left',class:'text-center',tdClass:' align-middle', sortable: true},

    {
        key: 'action',
        label: 'Actions',
        tdClass:' align-middle'
    }
])

const customActions = ref([
    {
        label: 'Extra Charge',
        variant: 'warning',
        icon: 'fas fa-bolt',
        action: (item) => {
        console.log('Extra charge action clicked for:', item);
        // Implement your extra charge logic here
        }
    },
    {
        label: 'Extend',
        variant: 'info',
        icon: 'fas fa-calendar-plus',
        action: (item) => {
        console.log('Reschedule action clicked for:', item);
        // Implement your Reschedule logic here
        }
    },
    {
        label: 'Order From Restaurant',
        variant: 'primary',
        icon: 'fas fa-utensils',
        action: (item) => {
        console.log('Edit action clicked for:', item);
        // Implement your edit logic here
        }
    },
    {
        label: 'Maintenance',
        variant: 'secondary',
        icon: 'fas fa-wrench',
        action: (item) => {
        console.log('Delete action clicked for:', item);
        // Implement your delete logic here
        }
    },
])
</script>